import httpClient from '../services/http-client';
import { isNil } from 'lodash';
import { API_SUB_URL_COMPANY } from '../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from './actions';
import {
    ADD_NEW_COMPANY, LOAD_LIST_COMPANY, LOAD_A_COMPANY, UPDATE_A_COMPANY, DELETE_A_COMPANY, UPLOAD_COMPANY_LOGO_FILE, DELETE_COMPANY_LOGO_FILE,
    FETCH_DATA_SUCCESS, FETCH_DATA_ERROR, FETCH_DATA_REQUEST
} from './actionTypes';

// Upload Files
export const apiUploadCompanyLogoFile = ({file, subPath}) => {
    let data = new FormData();
    data.append('uri', file);

    let uploadURL = '/upload';
    if(subPath) {
        uploadURL += `?subPath=${subPath}`;
    }

    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(uploadURL, data, { headers: { "Content-Type": "multipart/form-data" } })
            .then(response => {
                dispatch(fetchDataSuccess(UPLOAD_COMPANY_LOGO_FILE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
}

export const apiDeleteCompanyLogoFile = ({id, subPath = null}) => {
    let uploadURL = `/upload/delete/${id}`;
    if(subPath) {
        uploadURL += `?subPath=${subPath}`;
    }

    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(uploadURL)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_COMPANY_LOGO_FILE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
}

// Companies
// export const apiLoadListCompany = ({ searchText, all, company_id, order_by, order_dir }) => {
export const apiLoadListCompany = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });
        // let query = "";
        // if(!isNil(searchText)) {
        //     query += (query.length > 0 ? "&&" : "") + ("searchText=" + searchText);
        // }

        // if(all === true) {
        //     query += (query.length > 0 ? "&&" : "") + ("all=true");
        // }

        // if(!isNil(company_id)) {
        //     query += (query.length > 0 ? "&&" : "") + ("company_id=" + company_id);
        // }

        // if(!isNil(order_by)) {
        //     query += (query.length > 0 ? "&&" : "") + ("order_by=" + order_by);
        // }
        
        // if(!isNil(order_dir)) {
        //     query += (query.length > 0 ? "&&" : "") + ("order_dir=" + order_dir);
        // }

        httpClient.get(`${API_SUB_URL_COMPANY}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_COMPANY, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadACompany = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_COMPANY}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_COMPANY, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewCompany = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_COMPANY, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_COMPANY, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateACompany = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_COMPANY}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_COMPANY, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteACompany = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_COMPANY}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_COMPANY, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};